import { AxiosRequestConfig } from "axios";
import client from "libs/HttpClient";

/**
 * Represents the structure of a request for listing redbird.
 */
interface ListRedbirdRequest {
  queryKey: [number, string, string];
}

/**
 * Service class for handling products types.
 */
class RedbirdService {
  static listRedbird(request: ListRedbirdRequest) {
    const page_no = request.queryKey[0];
    const searchText = request.queryKey[1];
    const status = request.queryKey[2];
    return client.get(
      `admin/redbird/list?page=${page_no}&search_text=${searchText}&status=${status}`,
      request as AxiosRequestConfig
    );
  }

  /**
   * Adds a new redbird based on the provided request.
   *
   * @param request - The request parameters for adding a redbird.
   * @returns A Promise that resolves to the Axios response for the add redbird request.
   */
  static addRedbird(request: any) {
    return client.post("admin/redbird/add", request, {
      headers: {
        "Content-type": "multipart/form-data",
      },
    });
  }
  /**
   * Updates the details of a redbird based on the provided request.
   *
   * @param request - The request parameters for updating a redbird.
   * @returns A Promise that resolves to the Axios response for the update redbird request.
   */
  static updateRedbird(request: any) {
    return client.post("admin/redbird/edit/", request, {
      headers: {
        "Content-type": "multipart/form-data",
      },
    });
  }

  /**
   * Retrieves the details of a redbird based on the provided parameters.
   *
   * @param params - The parameters for retrieving the redbird details.
   * @returns A Promise that resolves to the Axios response containing the redbird details.
   */
  static viewRedbird(params: any) {
    return client.get("admin/redbird/get", { params });
  }

  /**
   * Deletes a redbird types based on the provided parameters.
   *
   * @param params - The parameters for deleting the redbird.
   * @returns A Promise that resolves to the Axios response for the delete redbird request.
   */
  static deleteRedbird(params: any) {
    return client.delete("/admin/redbird/delete/", { params });
  }
}

export { RedbirdService };
